<template>
    <section class="homevideo">
        <div class="homevideo__container">
            <div class="homevideo__background">
                <div class="homevideo__background__video">
                    <figure class="homevideo__background__asset">
                        <video 
                            autoplay
                            class="video"
                            v-on:loadstart="isloading = true"
                            v-on:oncanplaythrough="isloading = false"
                            v-bind:class="{loading: isloading}"
                            data-load="objectFit"
                            loop
                            muted
                            poster="/images/uptown-creative-video-opening.jpg"
                            playsinline>
                            <source data-src="https://api.uptowncreative.io/uploads/_/assets/chadrogers/uptowncreative-bg-video.mp4" type="video/mp4" src="https://api.uptowncreative.io/uploads/_/assets/chadrogers/uptowncreative-bg-video.mp4">
                        </video>
                    </figure>
                </div>
                <div class="homevideo__background__mobile">
                    <figure class="homevideo__background__asset">
                        <img src="/images/uptowncreative-intro-video.jpg">
                    </figure>
                </div>
            </div>
            <div class="homevideo__gradient"></div>
            <div class="homevideo__foreground">
                <div class="homevideo__content">
                    <h2 class="title">
                        {{title}}
                    </h2>
                    <p v-html="subtitle">
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.homevideo{
    &__container{
        height: calc(100vh - 60px);
        width: 100%;
        min-height: 480px;
    }
    &__background{
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        &__video{
            display:block;
            &.isloading{
                background: url("/images/uptowncreative-intro-video.jpg") cover;
            }
        }
        &__asset{
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            .video{
                position: relative;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        &__mobile{
            display: none;
            img{
                height: 100%;
                width: 100%;
                object-fit: cover;
            }
        }
    }
    &__gradient{
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        //background-image: linear-gradient(to bottom, #000, #000);
        //opacity: 0.35;
    }
    &__foreground{
        position: relative;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        text-align: center;
        color: #fff;
        h2{
            font-size: 50px;
            line-height: 55px;
            margin: 0 20%;
            margin-bottom: 1rem;
        }
        p{
            color: #fff;
            margin: 0 30%;
        }
    }
}
figure{
    padding: 0;
    margin: 0;
}

@media (max-width: 768px) {
    .homevideo{
        &__foreground{
            h2{
                margin: 0 20px 2rem;
            }
            p{
                margin: 0 30px;
            }
        }
    }
}
</style>

<script>
export default {
    name:"HomeVideo",
    data(){
        return{
            isloading: true,
            title: "We help brands grow and make great first impressions!",
            subtitle: "Full service digital marketing serving<br> clients across North America."
        }
    }
}
</script>